import * as z from "zod";
import { requiredErrorMessage } from "../common/error-messages";

export const addProductCategorySchema = z.object({
  name: z
    .string()
    .min(1, requiredErrorMessage)
    .max(100, "Name must be at most 100 characters.")
    .refine(
      (val) => val.length === 0 || /^[a-zA-Z0-9/\s\-_.&()']+$/.test(val),
      "Name can only contain letters, numbers, spaces, forward slashes, hyphens, underscores, periods, ampersands, parentheses, and apostrophes."
    ),
});
